module.exports = __webpack_public_path__ + "img/example_3.67f79c74.png";